import { View } from "../../View";
import { Popover, Typography } from "@mui/material";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(({ typography }) => ({
  container: {
    padding: "10px 10px 0 10px",
  },
  title: {
    fontSize: "15px",
    fontWeight: "bold",
    marginBottom: "10px",
  },
  itemContainer: {
    maxHeight: "250px",
    overflow: "auto",
  },
}));

export const BaseSummaryPopover = ({
  children,
  id,
  title,
  width = "300px",
  open,
  anchorEl,
  onClose,
}) => {
  const styles = useStyles();

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      PaperProps={{
        style: { width: width },
      }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <View className={styles.container}>
        <Typography className={styles.title}>{title}</Typography>
        <View className={styles.itemContainer}>{children}</View>
      </View>
    </Popover>
  );
};
